import React, { useEffect } from 'react';
import { bodyScrollLockExists, disableBodyScroll, enableBodyScroll } from './RemoveScroll.utils';
/**
 * Disables scrolling on the body
 *
 * Intended for use with modals and other popups
 */
var RemoveScroll = function (_a) {
    var children = _a.children;
    useEffect(function () {
        disableBodyScroll();
        return function () {
            // On unmount, ensure that no instances of .body-scroll-lock are left
            if (!bodyScrollLockExists()) {
                enableBodyScroll();
            }
        };
    }, []);
    return React.createElement("div", { className: "body-scroll-lock" }, children);
};
export default RemoveScroll;
